import styled from 'styled-components';

import Flex from '../../../../atoms/flex';

export const Buttons = styled(Flex)`
  padding-bottom: 24px;
`;